import { OrdersTableOptions } from '../types';

export const DATA_HC_NAME_ORDERS_TABLE_CELL = 'order-table-cell';
export const ORDERS_PER_PAGE = 20;
export const ORDERS_TABLE_OPTIONS: OrdersTableOptions[] = [
  'name',
  'label',
  'createdAt',
  'actualDeliveryDate',
  'orderItemsCount',
  'orderType',
  'status',
  'action',
];
export const ORDER_FILTER_IDS = {
  ownerId: 'ownerId',
  page: 'page',
  pageSize: 'pageSize',
  search: 'search',
  sortBy: 'sortBy',
  sortOrder: 'sortOrder',
  status: 'status',
} as const;
